const searchInput = document.querySelector('#search-input');
const dropdown = document.querySelector('#search-suggestions');

function debounce(fn, delay) {
    let timer;
    return (...args) => {
        clearTimeout(timer);
        timer = setTimeout(() => fn(...args), delay);
    };
}

async function fetchSuggestions(term) {
    const res = await fetch(
        `/api/search/suggestions?term=${encodeURIComponent(term)}&culture=${encodeURIComponent(currCulture)}`
    );
    return await res.json();
}

searchInput.addEventListener('input', debounce(async (e) => {
    const term = e.target.value.trim();

    if (term.length < 3) {
        dropdown.innerHTML = '';
        dropdown.classList.remove('--open');
        return;
    }

    const suggestions = await fetchSuggestions(term);
    renderSuggestions(suggestions);
}, 200));

function renderSuggestions(items) {
    if (!items.length) {
        dropdown.innerHTML = '';
        dropdown.classList.remove('--open');
        return;
    }

    dropdown.innerHTML = items
        .map(i => `<li><a href="${i.url}">${i.title}</a></li>`)
        .join('');

    dropdown.classList.add('--open');
}